<template>
  <section id="box_sso" class="box_sso">
    <!--<SSOBackground v-if="!$Store.User().isHideMsg" />-->
    <div class="container">
      <div class="box_table">
        <div class="cell">
          <a-row v-if="expand.isShow">
            <!--<a-col :xs="24" :lg="!$Store.User().isHideMsg?12:24" style="display: flex;align-items: center;justify-content: center;">-->
            <a-col :xs="24" style="display: flex;align-items: center;justify-content: center;">
              <a-form ref="form"
                      :model="form.data" :rules="form.rule">
                <!--<i class="logo" v-if="!$Store.User().isHideMsg" />-->
                <!--<a-typography-title :level="1">-->
                <!--    登录/注册-->
                <!--</a-typography-title>-->
                <a-typography-title :level="2">
                  <template v-if="!form.data.wechat_uid">
                    <!--现在注册应用市场-->
                    <!--<template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)">，</template>-->
                    <!--<br v-else />即刻免费体验30分钟AI应用-->
                    <!--在校师生福利！<br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.LG)" />充值100元赠送2000消耗点！多充多送！-->
                    <!--注册即送100消费点-->
                    <!--<template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)">，</template>-->
                    <!--<br v-else />-->
                    <!--欢迎注册体验～-->
                  </template>
                  <template v-else>
                    微信注册成功
                    <template v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)">，</template>
                    <br v-else />请先绑定手机号
                  </template>
                </a-typography-title>
                <a-form-item name="phone" has-feedback>
                  <a-input v-model:value="form.data.phone" placeholder="手机号"
                           :maxlength="$Check.Constraint.Phone"
                           :show-count="form.data.phone.length>0" allow-clear>
                    <template #prefix>
                      <MobileOutlined class="input_icon" />
                    </template>
                  </a-input>
                </a-form-item>
                <a-row class="box_auth">
                  <a-col :span="13">
                    <a-form-item name="code" has-feedback>
                      <a-input v-model:value="form.data.code" placeholder="验证码"
                               :maxlength="$Check.Constraint.AuthX"
                               :show-count="form.data.code.length>0" allow-clear>
                        <template #prefix>
                          <SafetyCertificateOutlined class="input_icon" />
                        </template>
                      </a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :offset="1" :span="10">
                    <a-button type="primary"
                              :loading="request.intercept.auth"
                              :disabled="setTime.countdown"
                              @click="getAuthCode" block>
                      {{ expand.countdown.text }}
                    </a-button>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col class="box_protocol" :span="24">
                    <a-form-item>
                      <a-checkbox v-model:checked="expand.protocol"
                                  color="geekblue">
                        <span>我已阅读并同意</span>
                        <a-button type="link" target="_blank"
                                  :href="$Config.Protocol.user">
                          用户注册协议
                        </a-button>
                        <span>和</span>
                        <a-button type="link" target="_blank"
                                  :href="$Config.Protocol.privacy">
                          隐私政策协议
                        </a-button>
                        <!-- <span style="margin:0 -2px">和</span>
                        <a-button type="link" target="_blank"
                                  :href="$Config.Protocol.disclaimers">
                          免责声明
                        </a-button> -->
                      </a-checkbox>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <a-button type="primary"
                              @click="submit" block>
                      {{ !form.data.wechat_uid ? '登录/注册' : '绑定手机号' }}
                    </a-button>
                  </a-col>
                  <a-col :span="24">
                    <a-button class="button_return"
                              @click="returnFromLogin" block>
                      返回
                    </a-button>
                  </a-col>
                  <a-col v-if="isShowWeChat"
                         :span="24">
                    <a-button type="link" class="button_register" v-if="!$Store.User().isHideMsg"
                              @click="weChatLogin" block>
                      <WechatOutlined />
                      微信登录
                    </a-button>
                  </a-col>
                </a-row>
              </a-form>
            </a-col>
            <!--<a-col v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)&&!$Store.User().isHideMsg"-->
            <!--       :xs="24" :lg="12">-->
            <!--  <SSOIntroduce />-->
            <!--</a-col>-->
          </a-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {
  MobileOutlined,
  SafetyCertificateOutlined,
  WechatOutlined
} from '@ant-design/icons-vue';

import { DataInterface, CookieEnum } from '@interface/public';
import {
  LoginTypeEnum, AuthTypeEnum, AuthUseEnum,
  RequestAuth, ResponseAuth, AxiosAuth,
  RequestRegister, ResponseRegister, AxiosRegister,
  RequestLogin, ResponseLogin, AxiosLogin
} from '@server/apiSSO';
import SSOBackground from '@template/sso/_component/background.vue';
import SSOIntroduce from '@template/sso/_component/introduce.vue';

export default {
  name: 'index',
  components: {
    MobileOutlined,
    SafetyCertificateOutlined,
    WechatOutlined,
    SSOBackground,
    SSOIntroduce
  },
  data(): DataInterface {
    return {
      setTime: {
        countdown: null
      },
      request: {
        intercept: {
          auth: false,
          submit: false
        }
      },
      form: {
        rule: {
          phone: [
            ...$Check.Rule.Phone(),
            {
              trigger: [ 'change', 'blur' ],
              validator: async (rule: any, value: any) => {
                value.length === 11 && await this.checkPhone();
                return Promise.resolve();
              }
            }
          ],
          code: $Check.Rule.Auth('')
        },
        data: {
          login_type: LoginTypeEnum.Phone,
          phone: '',
          code: '',
          source: $Store.User().sourceAccess,
          invitation_code: $Store.User().invite,
          wechat_uid: this.$route.query.wechat || '',
          un_bound: this.$route.query.un_bound,
        }
      },
      expand: {
        isShow: false,
        countdown: {
          current: 0,
          total: 60,
          text: '获取验证码'
        },
        protocol: false,
        protocolVersion: '20231214',
        isRegister: false
      }
    };
  },
  computed: {
    isShowWeChat() {
      return !this.form.data.wechat_uid &&
             window?.GFConfig?.type !== 'Android' &&
             window?.GFConfig?.type !== 'APK';
    }
  },
  mounted(): void {
    const operate: string = $Store.User().operate || '';
    // $RQ.PushWebHookFeiShu(
    //   '测试登录',
    //   `登录:name:${ $Store.User().username },$RQ.SSO.check():${ $RQ.SSO.check() },source:${ $Store.User().source  },operate:${ operate },wechat_uid:${ this.form.data.wechat_uid }`
    // );
    if ($RQ.SSO.check()) {
      this.$router.push($Enum.RouterEnum.Replenish);
      return;
    }
    if ($Store.User().source === $Enum.OperateEnum.WeChatLogin && !this.form.data.un_bound) {
      $RQ.WeChatAuthorized();
      return;
    }

    if(window?.GFOnMessage){
      window?.GFOnMessage((type: string, data: { error: any; code: any; }) => {
          if (type === 'wechat_login_result') {
            if (data.error) {
              this.$message.error(data.error||'微信登录失败');
              return;
            }

            // ✅ 用 code 走你原有的 SSO 登录
            location.href = $FN.Url.set(
              { code: data.code },
              $Config.Href.sso + $Enum.RouterEnum.ChannelWeChat
            );
          }
      });
    }
    
    this.expand.isShow = true;
  },
  methods: {
    /**
     * 根据运行环境退出当前登录页面
     */
    returnFromLogin(): void {
      const miniProgram = window.wx?.miniProgram;
      const returnParam = this.$route.query.mini_return;
      const returnUrl = typeof returnParam === 'string' && /^\/pages\/[\w/-]+$/.test(returnParam)
        ? returnParam
        : '/pages/index/index';

      if (!miniProgram?.redirectTo) {
        this.returnToBrowser();
        return;
      }

      // redirectTo 会销毁当前小程序 WebView 页面，不经过 SSO 网页历史。
      miniProgram.redirectTo({
        url: returnUrl,
        fail: (error: any) => {
          console.error('关闭小程序 WebView 失败，尝试重建页面栈', error);
          miniProgram.reLaunch({ url: returnUrl });
        }
      });
    },

    /**
     * 返回普通网页的来源页面，无来源时回到应用市场
     */
    returnToBrowser(): void {
      if (window.opener && !window.opener.closed) {
        window.close();
        return;
      }

      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.href = $Config.Href.store;
    },

    /**
     * 倒计时
     */
    countdown(): void {
      this.expand.countdown.current = this.expand.countdown.total;
      this.expand.countdown.text = `${ this.expand.countdown.current }秒后重新获取`;
      
      this.setTime.countdown && clearInterval(this.setTime.countdown);
      this.setTime.countdown = setInterval(() => {
        if (this.expand.countdown.current <= 0) {
          clearInterval(this.setTime.countdown);
          this.setTime.countdown = null;
          
          this.expand.countdown.text = '获取验证码';
          return;
        }
        
        this.expand.countdown.current--;
        this.expand.countdown.text = `${ this.expand.countdown.current }秒后重新获取`;
      }, 1000);
    },
    
    /**
     * 校验手机号
     */
    async checkPhone(): Promise<any> {
      this.expand.isRegister = await $RQ.CheckPhone(this.form.data.phone);
    },
    
    /**
     * 获取授权码
     */
    async getAuthCode(): Promise<any> {
      await this.$refs.form.validateFields([ 'phone' ])
        .then(async () => {
          if (this.request.intercept.auth || this.expand.countdown.current !== 0) return;
          this.request.intercept.auth = true;
          
          await AxiosAuth({
            usage: this.expand.isRegister
              ? AuthUseEnum.Login
              : AuthUseEnum.Register,
            target_type: AuthTypeEnum.Phone,
            target: this.form.data.phone
          } as RequestAuth)
            .then((response: any) => {
              const data: ResponseAuth = response.data;
              
              if (data.code !== $Enum.CodeEnum.Normal) return;
              
              this.countdown();
              $FN.Message('success', {
                content: $Enum.TextEnum.SuccessGet
              });
            })
            .finally(() => {
              this.request.intercept.auth = false;
            });
        })
        .catch(() => {
          $FN.Message('warning', {
            content: $Enum.TextEnum.ErrorCheckFail
          });
        });
    },
    
    /**
     * 提交
     */
    async submit(): Promise<any> {
      await this.$refs.form.validateFields()
        .then(async () => {
          // 如果是新注册用户 协议版本号为最新
          if (!this.expand.isRegister) {localStorage.setItem('protocolVersion', JSON.stringify(this.expand.protocolVersion));}
          // if ((!this.expand.isRegister && !this.expand.protocol) || JSON.parse(localStorage.getItem('protocolVersion')) !== this.expand.protocolVersion) {
          if (!this.expand.protocol) {
            $Store.SSO().openModal('modalProtocol', {
              callback: () => {
                this.expand.protocol = true;
                localStorage.setItem('protocolVersion', JSON.stringify(this.expand.protocolVersion));
                this.submit();
              }
            });
            return;
          }
          
          if (this.request.intercept.submit) return;
          this.request.intercept.submit = true;
          
          if (!this.expand.isRegister) {
            await AxiosRegister({
              // login_type: this.form.data.login_type,
              phone: this.form.data.phone,
              code: Number(this.form.data.code),
              source: this.form.data.source,
              invitation_code: this.form.data.invitation_code,
              wechat_uid: this.form.data.wechat_uid,
              source_addr: $Store.User().source
            } as RequestRegister)
              .then(async (response: any) => {
                const data: ResponseRegister = response.data;
                
                if (data.code !== $Enum.CodeEnum.Normal) return;
                
                $Store.User().updateInfo({
                  token: data.data.token,
                  userID: data.data.user_id || '-',
                  username: data.data.name || data.data.user_id || '-'
                });
                !$Store.User().operate && $Store.User().$patch({
                  operate: $Enum.OperateEnum.Register
                });
                
                $FN.Message('success', {
                  // content: `${ $Enum.TextEnum.SuccessRegister }，请继续完善个人信息`
                  content: $Enum.TextEnum.SuccessRegister
                });
                
                this.$router.push($Enum.RouterEnum.Replenish);
                
                $RQ.PushWebHookFeiShu(
                  $Store.User().username || this.form.data.phone,
                  `${ (this.form.data.wechat_uid ? '微信' : '') + $Enum.TextEnum.OperateRegister }：${ $Store.User().source || location.href }`
                );
                
                $RQ.PushWebHookBaiduPromotion($Store.User().bdVid);
              })
              .finally(() => {
                this.request.intercept.submit = false;
              });
          } else {
            await AxiosLogin({
              login_type: this.form.data.login_type,
              phone: this.form.data.phone,
              code: Number(this.form.data.code),
              wechat_uid: this.form.data.wechat_uid
            } as RequestLogin)
              .then(async (response: any) => {
                const data: ResponseLogin = response.data;
                
                if (data.code === $Enum.CodeEnum.UserCanceling) {
                  this.handleCancelingUser(data);
                  return;
                }
                if (data.code !== $Enum.CodeEnum.Normal) return;
                
                $Store.User().updateInfo({
                  token: data.data.token,
                  userID: data.data.user_id || '-',
                  username: data.data.name || data.data.user_id || '-'
                });
                !$Store.User().operate && $Store.User().$patch({
                  operate: $Enum.OperateEnum.Login
                });
                
                $FN.Message('success', {
                  content: $Enum.TextEnum.SuccessLogin
                });
                
                this.$router.push($Enum.RouterEnum.Replenish);
                
                $RQ.PushWebHookFeiShu(
                  $Store.User().username || this.form.data.phone,
                  `${ (this.form.data.wechat_uid ? '微信' : '') + $Enum.TextEnum.OperateLogin }：${ $Store.User().source || location.href }`
                );
              })
              .finally(() => {
                this.request.intercept.submit = false;
              });
          }
        })
        .catch(() => {
          $FN.Message('warning', {
            content: $Enum.TextEnum.ErrorCheckFail
          });
        });
    },
    
    /**
     * 处理注销中登录
     * @param {*} data 登录结果
     */
    handleCancelingUser(data: any): void {
      if (!data.data?.token) return;
      
      const cancelledAt = data.data.cancelled_at || data.data.cancelledAt ||
        data.cancelled_at || data.cancelledAt || '';
      cancelledAt &&
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.setItem('GFStopCancelCancelledAt', cancelledAt);
      
      $Store.User().updateInfo({
        token: data.data.token,
        userID: data.data.user_id || data.data.uid || '-',
        username: data.data.name || data.data.user_id || data.data.uid || '-'
      });
      !$Store.User().operate && $Store.User().$patch({
        operate: $Enum.OperateEnum.StopCancel
      });
      
      this.$router.push({
        path: $Enum.RouterEnum.StopCancel,
        query: {
          cancelled_at: cancelledAt
        }
      });
    },
    
    /**
     * 微信登录
     */
    weChatLogin(): void {
      if (!this.expand.protocol) {
        $Store.SSO().openModal('modalProtocol', {
          callback: () => {
            $RQ.WeChatAuthorized();
          }
        });
      } else {
        $RQ.WeChatAuthorized();
      }
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
@import '@resource/css/sso.less';

@image: '@{src_image}sso/';

.box_sso {
  .button_return {
    height: 44px;
    margin-top: 12px;
    border-color: fade(@color_black, 25);
    color: fade(@color_black, 75);
  }

  .logo {
    display: none;
    margin: 0 0 50px;
    .bg('@{imagePublic}logo_black.png', 448px*0.5, 137px*0.5, true);
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_sso {
    .logo {
      display: block;
      margin: 0 0 20px;
      .bg('@{imagePublic}logo_black.png', 448px*0.3, 137px*0.3, true);
    }
    
    .ant-form {
      background: fade(@color_white, 95);
      .shadow(0 10px 30px fade(@color_black, 10));
    }
  }
}
</style>
